// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialop-popup-badges-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.5rem 0rem;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dialop-popup-badges-label {
  font-size: var(--ui-font-sm);
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.dialop-popup-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.dialop-popup-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.5rem 0.375rem 0.75rem;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  border-radius: 20px;
  font-size: var(--ui-font-sm);
  font-weight: 500;
  line-height: 1;
  animation: badgeIn 0.2s ease-out;
  transition: all 0.2s ease;
}

@keyframes badgeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.dialop-popup-badge:hover {
  background: linear-gradient(135deg, var(--tertiary-color), var(--secondary-color));
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.dialop-popup-badge-text {
  white-space: nowrap;
}

.dialop-popup-badge-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.dialop-popup-badge-remove:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.dialop-popup-badge-remove:active {
  transform: scale(0.95);
}

@media (max-width: 550px) {
  .dialop-popup-badges {
    gap: 0.375rem;
  }

  .dialop-popup-badge {
    font-size: var(--ui-font-xs-plus);
    padding: 0.25rem 0.375rem 0.25rem 0.5rem;
  }

  .dialop-popup-badge-remove {
    width: 16px;
    height: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DialogPopup/DialogPopupOptions/DialogPopupOptions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,iFAAiF;EACjF,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kFAAkF;EAClF,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iCAAiC;IACjC,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".dialop-popup-badges-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0.5rem 0rem;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dialop-popup-badges-label {\n  font-size: var(--ui-font-sm);\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.dialop-popup-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.dialop-popup-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem 0.5rem 0.375rem 0.75rem;\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\n  color: white;\n  border-radius: 20px;\n  font-size: var(--ui-font-sm);\n  font-weight: 500;\n  line-height: 1;\n  animation: badgeIn 0.2s ease-out;\n  transition: all 0.2s ease;\n}\n\n@keyframes badgeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.dialop-popup-badge:hover {\n  background: linear-gradient(135deg, var(--tertiary-color), var(--secondary-color));\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);\n}\n\n.dialop-popup-badge-text {\n  white-space: nowrap;\n}\n\n.dialop-popup-badge-remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border: none;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.dialop-popup-badge-remove:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.dialop-popup-badge-remove:active {\n  transform: scale(0.95);\n}\n\n@media (max-width: 550px) {\n  .dialop-popup-badges {\n    gap: 0.375rem;\n  }\n\n  .dialop-popup-badge {\n    font-size: var(--ui-font-xs-plus);\n    padding: 0.25rem 0.375rem 0.25rem 0.5rem;\n  }\n\n  .dialop-popup-badge-remove {\n    width: 16px;\n    height: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
